export const HEADER_HEIGHT = 44;
export const DEFAULT_SIDER_WIDTH = 208;
export const MIN_SIDER_WIDTH = 180;
export const MAX_SIDER_WIDTH = 260;
export const COLLAPSED_SIDER_WIDTH = 64;
export const RESIZE_HANDLE_HITBOX = 12;
